(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewlume-model-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sewlume-model-finder')) {
  customElements.define('sewlume-model-finder', class extends HTMLElement {
    static storageKey = 'sewlume:machine';
    static handlePattern = /^[a-z0-9][a-z0-9-]*$/;
    static norm(value) {
      return String(value).normalize('NFKC').toLowerCase().replace(/[\s\-_\/]+/g, '');
    }
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.events = new AbortController();
      this.version = 0;
      this.brand = this.querySelector('[data-brand]');
      this.model = this.querySelector('[data-model]');
      this.list = this.querySelector('[data-suggestions]');
      this.go = this.querySelector('[data-go]');
      this.confirmation = this.querySelector('[data-confirmation]');
      this.contact = this.querySelector('[data-contact]');
      if (this.brand.options.length < 2) { this.brand.disabled = true; this.say('unavailable'); return; }
      this.on(this.brand, 'change', () => {
        this.reset(); this.model.value = ''; this.model.disabled = !this.brand.value;
        if (!this.brand.value) { this.say('needBrand'); return; }
        this.say('loading');
        this.load().then(() => { if (this.brand.value) { this.say('ready'); this.model.focus(); } }, () => this.fail());
      });
      this.on(this.model, 'input', () => this.search());
      this.on(this.model, 'keydown', event => {
        if (event.key === 'ArrowDown' && !this.list.hidden) { event.preventDefault(); this.list.querySelector('button')?.focus(); }
        if (event.key === 'Escape') this.close();
      });
      this.on(this.list, 'keydown', event => {
        const buttons = [...this.list.querySelectorAll('button')];
        const index = buttons.indexOf(document.activeElement);
        if (event.key === 'Escape') { this.close(); this.model.focus(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (event.key === 'ArrowUp' && index <= 0) { this.model.focus(); return; }
          buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length]?.focus();
        }
      });
      this.on(this.querySelector('form'), 'submit', event => { event.preventDefault(); if (this.picked) this.open(this.picked); });
      this.on(this.querySelector('[data-forget]'), 'click', () => { this.store(null); this.querySelector('[data-remembered]').hidden = true; this.brand.focus(); });
      this.say(this.brand.value ? 'ready' : 'needBrand');
      this.model.disabled = !this.brand.value;
      if (this.recall()) this.load().then(() => this.showRemembered(), () => {});
    }
    disconnectedCallback() { this.events?.abort(); this.started = false; }
    on(element, type, handler) { element?.addEventListener(type, handler, { signal: this.events.signal }); }
    say(key) { this.querySelector('[data-status]').textContent = this.dataset['msg' + key[0].toUpperCase() + key.slice(1)] || ''; }
    fail() { this.reset(); this.model.disabled = true; this.say('unavailable'); if (this.contact) this.contact.hidden = false; }
    close() { this.list.hidden = true; this.model.setAttribute('aria-expanded', 'false'); }
    reset() {
      this.version++;
      this.picked = null; this.go.disabled = true;
      this.confirmation.hidden = true; this.confirmation.textContent = '';
      this.list.replaceChildren(); this.close();
      if (this.contact) this.contact.hidden = true;
    }
    load() {
      if (!this.index) {
        this.index = fetch(this.dataset.indexUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(response => { if (!response.ok) throw new Error('index ' + response.status); return response.text(); })
          .then(html => {
            const script = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-sw-finder-index]');
            if (!script) throw new Error('index missing');
            return this.parse(JSON.parse(script.textContent));
          });
        this.index.catch(() => { this.index = null; });
      }
      return this.index;
    }
    parse(data) {
      if (!data || data.v !== 1 || !Array.isArray(data.brands)) throw new Error('index shape');
      const norm = this.constructor.norm, byBrand = new Map(), byHandle = new Map();
      data.brands.forEach(group => {
        if (!group || typeof group.brand !== 'string' || !group.brand.trim() || !Array.isArray(group.models)) return;
        const rows = [], brandKey = norm(group.brand);
        group.models.forEach(row => {
          if (!Array.isArray(row) || row.length < 2) return;
          const [handle, name, aliases = []] = row;
          if (typeof handle !== 'string' || !this.constructor.handlePattern.test(handle)) return;
          if (typeof name !== 'string' || !name.trim() || !Array.isArray(aliases)) return;
          const cleanAliases = aliases.filter(alias => typeof alias === 'string' && alias.trim());
          const nameKey = norm(name);
          const keys = [{ key: nameKey }, { key: nameKey.startsWith(brandKey) ? nameKey.slice(brandKey.length) : nameKey }]
            .concat(cleanAliases.map(alias => ({ key: norm(alias), alias: nameKey.includes(norm(alias)) ? undefined : alias })));
          const entry = { handle, name, keys };
          rows.push(entry); byHandle.set(handle, entry);
        });
        byBrand.set(group.brand, rows);
      });
      return { byBrand, byHandle };
    }
    async search() {
      this.reset();
      const version = this.version, brand = this.brand.value, query = this.constructor.norm(this.model.value);
      if (!brand) { this.say('needBrand'); return; }
      if (!query) { this.say('ready'); return; }
      let index;
      try { index = await this.load(); } catch { if (version === this.version) this.fail(); return; }
      if (version !== this.version) return;
      const matches = [];
      (index.byBrand.get(brand) || []).forEach(entry => {
        let best = null;
        entry.keys.forEach(({ key, alias }) => {
          if (!key) return;
          const rank = key === query ? 0 : key.startsWith(query) ? 1 : key.includes(query) ? 2 : null;
          if (rank !== null && (!best || rank < best.rank)) best = { rank, alias };
        });
        if (best) matches.push({ entry, ...best });
      });
      matches.sort((a, b) => a.rank - b.rank || a.entry.name.localeCompare(b.entry.name, undefined, { numeric: true }));
      const shown = matches.slice(0, 12);
      shown.forEach(({ entry, alias }) => {
        const item = document.createElement('li'), button = document.createElement('button');
        button.type = 'button'; button.textContent = entry.name;
        if (alias) { const note = document.createElement('small'); note.textContent = this.dataset.labelAlias + ' ' + alias; button.append(note); }
        this.on(button, 'click', () => { if (version === this.version) this.pick(entry); });
        item.append(button); this.list.append(item);
      });
      this.list.hidden = !shown.length;
      this.model.setAttribute('aria-expanded', String(Boolean(shown.length)));
      if (!shown.length) { this.say('noModels'); if (this.contact) this.contact.hidden = false; return; }
      this.say(matches.length > shown.length ? 'more' : 'choose');
    }
    pick(entry) {
      this.reset();
      this.picked = entry; this.model.value = entry.name;
      this.confirmation.textContent = this.dataset.labelSelected + ' ' + entry.name;
      this.confirmation.hidden = false; this.go.disabled = false;
      this.say('choose'); this.go.focus();
    }
    url(handle) { return (this.dataset.root || '/').replace(/\/?$/, '/') + 'collections/' + handle; }
    open(entry) { this.store(entry); this.navigate(this.url(entry.handle)); }
    navigate(url) { window.location.assign(url); }
    store(entry) {
      try {
        if (entry) localStorage.setItem(this.constructor.storageKey, JSON.stringify({ handle: entry.handle, name: entry.name }));
        else localStorage.removeItem(this.constructor.storageKey);
      } catch {}
    }
    recall() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.constructor.storageKey) || 'null');
        return saved && typeof saved.handle === 'string' && this.constructor.handlePattern.test(saved.handle) ? saved : null;
      } catch { return null; }
    }
    async showRemembered() {
      const saved = this.recall(), index = await this.load();
      const entry = saved && index.byHandle.get(saved.handle);
      if (!entry) { if (saved) this.store(null); return; }
      const link = this.querySelector('[data-remembered-link]');
      link.textContent = entry.name; link.href = this.url(entry.handle);
      this.querySelector('[data-remembered]').hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewlume-model-header"]) return;
  try {
    
(() => {
  const apply = () => {
    document.querySelectorAll('script[data-sw-fitting-variants]').forEach(script => {
      let map;
      try { map = JSON.parse(script.textContent); } catch { return; }
      if (!map || typeof map !== 'object' || Array.isArray(map)) return;
      document.querySelectorAll('a[href*="/products/"]').forEach(link => {
        let url;
        try { url = new URL(link.getAttribute('href'), location.origin); } catch { return; }
        if (url.origin !== location.origin) return;
        const handle = (/\/products\/([^/?#]+)/.exec(url.pathname) || [])[1];
        const ids = handle && Array.isArray(map[handle]) ? map[handle].map(String).filter(id => /^[0-9]+$/.test(id)) : [];
        if (!ids.length) return;
        if (ids.includes(url.searchParams.get('variant') || '')) return;
        url.searchParams.set('variant', ids[0]);
        link.setAttribute('href', url.pathname + url.search + url.hash);
        link.dataset.swFittingVariant = ids[0];
      });
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; apply(); });
  };
  const start = () => {
    apply();
    if (!document.querySelector('script[data-sw-fitting-variants]')) return;
    // Collection filtering/pagination re-renders the grid in place on most themes.
    new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) schedule(); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', apply);
})();

  } catch(e) { console.error(e); }
})();
})();
